<template>
    <!--begin::Submit button-->
    <button
        type="submit"
        class="btn btn-primary"
        :class="{disabled: processing, 'd-flex align-items-center': icon}"
        :disabled="processing"
        :data-kt-indicator='processing ? "on" : "off"'
    >
        <i class="bi" :class="icon" v-if="icon && !processing"></i>
        <span class="indicator-label">{{ label }}</span>
        <span class="indicator-progress">{{ loadingText }}
            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
        </span>
    </button>
    <!--end::Submit button-->
</template>

<script>
export default {
    props: {
        icon: {
          required: false,
          type: String,
          default: ''
        },
        label: {
            required: false,
            default: 'Enviar'
        },

        loadingText: {
            required: false,
            default: 'Aguarde...'
        },

        processing: {
            type: Boolean,
            required: false,
            deafult: false,
        }
    },
}
</script>
